/** The type of status to be rendered. */
enum StatusType {
  Adequacy = "adequacy",
  Accuracy = "accuracy",
  Attestation = "attestation",
}

/** Defines the rendering order for the status types. */
const statusTypeRenderingOrder = {
  [StatusType.Adequacy]: 1,
  [StatusType.Attestation]: 2,
  [StatusType.Accuracy]: 3,
};

/** The type of band to be rendered. */
enum BandType {
  Green = "green",
  Yellow = "yellow",
  Red = "red",
  Blue = "blue",
  Projected = "projected",
}

/** Defines the rendering index for the band types. */
const bandTypeRenderingIndex = {
  [BandType.Blue]: 0,
  [BandType.Green]: 0,
  [BandType.Yellow]: 1,
  [BandType.Red]: 2,
  [BandType.Projected]: 0,
};

/** Defines the rendering order for the band types. */
const bandTypeRenderingOrder = {
  [BandType.Blue]: 0,
  [BandType.Green]: 1,
  [BandType.Yellow]: 2,
  [BandType.Red]: 3,
  [BandType.Projected]: 4,
};

export {
  StatusType,
  statusTypeRenderingOrder,
  BandType,
  bandTypeRenderingIndex,
  bandTypeRenderingOrder,
};
